import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20minimalist%20abstract%20composition%20with%20flowing%20organic%20shapes%20in%20warm%20terracotta%20and%20sage%20green%20tones%2C%20gentle%20layered%20curves%20and%20circles%2C%20subtle%20grain%20texture%2C%20light%20airy%20atmosphere%2C%20modern%20clean%20aesthetic%2C%20professional%20yet%20approachable%20feel%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20no%20people%2C%20editorial%20quality%20background&width=1800&height=900&seq=hero-bg-vigorbuy-v2&orientation=landscape"
          alt="VigorBuy Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/8 to-black/25"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-700 mb-6">
            <i className="ri-shield-check-line text-accent-500"></i>
            <span>Trusted Resource For Spreadsheet Users</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            VigorBuy Spreadsheet:<br />
            <span className="text-white/90">The Complete Resource For Smarter</span><br />
            <span className="text-white/90">Spreadsheet Management</span>
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Everything you need to understand VigorBuy Spreadsheet. Explore guides, templates, 
            comparisons, tutorials and expert insights designed to help you manage data faster 
            and more efficiently.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              Explore VigorBuy Spreadsheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <Link
              to="/blog/what-is-vigorbuy-spreadsheet-complete-guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-white/90 backdrop-blur-sm text-foreground-900 text-base font-semibold hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Read Complete Guide
              <i className="ri-book-open-line ml-2"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              { icon: 'ri-shield-check-line', text: 'Secure Information' },
              { icon: 'ri-refresh-line', text: 'Updated Resources' },
              { icon: 'ri-award-line', text: 'Expert Guides' },
              { icon: 'ri-stack-line', text: 'Spreadsheet Knowledge Base' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/70 text-sm">
                <i className={item.icon}></i>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}